// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__8HIIE","footer":"Form_footer__1RnxB"};